module.exports = __webpack_public_path__ + "static/assets/1b2fd5d8033553ba16172fd70f56a2e8.png";